import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import logger from 'ws-scripts/modules/logger';
import { ButtonList } from 'wsm-vehicle-cta-display';
import { ErrorBoundary } from 'wsm-error-boundary';
import { isBrowser } from 'ws-scripts/modules/environment';
import { usePrefs, useRequestData } from 'wsm-common-data';
import { getTargetLocations } from '../utils/getTargetLocations';

const Widget = () => {
	const { items, vehicle } = useSelector((state) => state);
	const { windowId } = useRequestData();

	useEffect(() => {
		if (isBrowser && window.DDC && window.DDC.pubsub) {
			setTimeout(
				() =>
					window.DDC.pubsub.publish(
						'ws-vehicle-ctas/render-eprice-portal'
					),
				1000
			);
		}
	}, []);

	const { restrictInsertLocationsForVehicles } = usePrefs();

	const targetLocations = getTargetLocations(
		vehicle,
		restrictInsertLocationsForVehicles
	);

	const itemsToDisplay = targetLocations.has('vehicle-ctas') ? [] : items;

	const portalMarkup = (
		<div
			className="eprice-react-portal"
			data-target-locations={[...targetLocations].join(' ')}
		/>
	);

	return (
		<ErrorBoundary
			newRelicPageAction="WS VEHICLE CTAS ERROR BOUNDARY"
			errorHandler={(error, errorInfo) => {
				const newError = new Error(
					`Encountered an error in ws-model-selector.\n${error}`
				);
				newError.originalError = error;
				newError.originalStackTrace = errorInfo.componentStack;
				logger.error(`${newError}\n${newError.originalStackTrace}`);
			}}
		>
			{windowId === 'vehicle-ctas1' && portalMarkup}
			<ButtonList
				buttons={itemsToDisplay}
				dataLocation={targetLocations}
			/>
		</ErrorBoundary>
	);
};

export default Widget;
